import { Component, OnInit, Inject, ɵConsole } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { UserService } from 'src/app/_service/user.service';
import { FormGroup, FormControl, FormBuilder, Validators, FormArray} from '@angular/forms';
import { CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY } from '@angular/cdk/overlay/typings/overlay-directives';
import { LocationService } from 'src/app/_service/location.service';
import { AlertifyService } from 'src/app/_service/alertify.service';
//import { AuthorityModel } from '../../_models/authority';

@Component({
  selector: 'app-add-site',
  templateUrl: './add-site.component.html',
  styleUrls: ['./add-site.component.css']
})
export class AddSiteComponent implements OnInit {
  authorities;
  selectedAuthority;
  siteAliasName;
  newSiteName;
  locationExists: any = {};
  locationAdded: any = {};
  model: any = {};
  newSiteAliasName: any;
  isModified = false;
  
  authorityInput = { 
    rootAuthorityUnitId: null,
    parentAuthorityUnitId: null,
    name: ''
  };

  locationForm: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public passedData: any,
    private userService: UserService,
    private locationService: LocationService,
    private fb: FormBuilder,
    private alertify: AlertifyService,
    public dialog: MatDialog) 
    {
      this.locationForm = fb.group({

        siteFormControl: new FormControl('', [
          Validators.required,
          // this.WhitespaceValidator
        ]),
        serviceareaFormControl: new FormControl('', [
          Validators.required,
          this.WhitespaceValidator
        ]),
        // locationFormControl: new FormControl('', [
        //   Validators.required
        // ]),
        // sublocationFormControl: new FormControl('', [
        //   Validators.required
        // ]),
        // departmentFormControl: new FormControl('', [
        //   Validators.required
        // ]),
        // subdepartmentFormControl: new FormControl('', [
        //   Validators.required
        // ]),
        aliasFormControl: new FormControl('', []).clearValidators(),
     });
    }

    public WhitespaceValidator(control: FormControl) {
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { 'whitespace': true };
  }

  ngOnInit() {
    this.getAllTopAuthority();
  }

  getAllTopAuthority() {
    return this.locationService.getAllTopAuthorityNames().subscribe(res => {
      this.authorities = res;
      // console.log(this.authorities);
    });
  }

  addSite() {
     this.model.rootAuthorityUnitId = this.selectedAuthority;
     this.model.parentAuthorityUnitId = this.selectedAuthority;
     this.model.name = this.newSiteName.trim();

     if (this.newSiteAliasName !== undefined) {
      this.model.alias = this.newSiteAliasName.trim();
     }
     
    // console.log('This is the model: ' + this.model);
    // console.log('Selected authorityId: ' + this.selectedAuthority);
     return this.locationService.insertNewSite(this.model).subscribe(
       res => {
        this.locationExists = res.headers.get('locationexists');
        if (this.locationExists) {
          this.alertify.error(this.locationExists);
        }
        this.locationAdded = res.headers.get('locationadded');
        if (this.locationAdded) {
          this.alertify.success(this.locationAdded);
          this.isModified = true;
          this.dialog.closeAll();
        }
   }, error => {
      this.alertify.error('Something went wrong');
    });
}

}


export interface AuthorityModel {
  parentAuthorityUnitId: number,
  rootAuthorityUnitId: number,
  name: string,
  authorityUnitOutsideId: string,
}